import React from 'react';
import ContactUs from '../../components/Contact';

function Contact() {

  return (
    <section className="space-y-16 mt-24 py-18">
      <div className=" mx-auto">
        <ContactUs />
      </div>
    </section>
  );
}

export default Contact;
